import { Ref, computed } from 'vue';
import { useDateFormat } from '@vueuse/core';
import { dateFromEpoch } from '../helpers';

export function useEventDate(ts: Ref<number>, dateFormat = 'DD.MM.YY') {
    const dateObject = computed(() => dateFromEpoch(ts.value));

    const date = useDateFormat(dateObject, dateFormat);
    const time = useDateFormat(dateObject, 'HH:mm');

    return {
        date,
        time,
        dateObject,
    };
}

